<script lang="ts">
	import { getContext } from "svelte";
	import { twMerge } from "tailwind-merge";
	import { Mode } from "#gen/bundles/v1/service_pb.js";
	import type { AssetLoad } from "#lib/api/bundles.js";
	import Icon from "#lib/components/Icon.svelte";
	import TokenizedImage from "#lib/components/TokenizedImage.svelte";
	import TokenizedText from "#lib/components/TokenizedText.svelte";
	import type { ModuleItemProps } from "#lib/components/flow/viewer/types.js";
	import { getAssetRef, getIconUrl, getText } from "#lib/components/flow/viewer/utils.js";
	import type { TokenProvider } from "#lib/tokenProvider.js";
	import type { Writable } from "svelte/store";

	const tokenProvider: Writable<TokenProvider> = getContext("tokenProvider");
	const assets: Writable<Record<string, AssetLoad>> = getContext("assets");
	const { suite, module, mode, classes, onShow, onEdit }: ModuleItemProps = $props();

	const ref = $derived(getAssetRef($suite, module));
	const iconUrl = $derived(getIconUrl($assets, module.key, ref, mode));
	const text = $derived(getText($assets, module.key, ref, mode));

	function handleEdit() {
		const asset = $assets[module.key];
		if (asset) {
			onEdit?.(asset);
		}
	}

	function handleShow() {
		onShow?.(module);
	}
</script>

<button data-flow-button type="button" onclick={mode === Mode.EDITING ? handleEdit : handleShow} class={twMerge("flex h-50 w-full flex-col overflow-hidden rounded-2xl bg-white p-0", classes.borderClass, classes.outlineClass, classes.readOnlyClass)} class:!opacity-50={ref?.disabled}>
	<div class="relative flex w-full grow items-center justify-center">
		<TokenizedImage provider={$tokenProvider} src={iconUrl} {mode} />
	</div>
	<div class="flex h-12 w-full items-center justify-between border-t border-gray-300 px-3 py-2.5">
		<div class="grow text-left text-sm font-semibold text-gray-900">
			<TokenizedText provider={$tokenProvider} {text} {mode} />
		</div>
		<Icon name="chevron-right" class="h-5 w-5 text-gray-400" />
	</div>
</button>
